<nav class="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <!-- Logo -->
      <a routerLink="/" class="flex items-center space-x-2" (click)="closeMenu()">
        <div class="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-700 rounded-lg flex items-center justify-center">
          <span class="text-white font-bold text-xl">H</span>
        </div>
        <span class="text-xl font-bold bg-gradient-to-r from-primary-600 to-primary-700 bg-clip-text text-transparent">
          HoneyKode
        </span>
      </a>

      <!-- Desktop Navigation -->
      <div class="hidden lg:flex items-center space-x-1">
        <!-- Home -->
        <a routerLink="/"
           routerLinkActive="text-primary-600 bg-primary-50"
           [routerLinkActiveOptions]="{exact: true}"
           class="px-3 py-2 text-sm font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200">
          Home
        </a>

        <!-- About -->
        <a routerLink="/about"
           routerLinkActive="text-primary-600 bg-primary-50"
           class="px-3 py-2 text-sm font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200">
          About
        </a>

        <!-- Services Mega Menu -->
        <div class="relative dropdown-container"
             (mouseenter)="openDropdown('services')"
             (mouseleave)="closeDropdown()">
          <button class="px-3 py-2 text-sm font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200 flex items-center gap-1">
            Services
            <svg class="w-4 h-4 transition-transform" [class.rotate-180]="activeDropdown === 'services'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          @if (activeDropdown === 'services') {
            <div class="absolute top-full left-1/2 -translate-x-1/2 mt-1 bg-white rounded-xl shadow-2xl border border-gray-100 py-4 z-50 w-[700px]">
              <div class="grid grid-cols-4 gap-4 px-4">
                @for (service of services; track service.label) {
                  <div class="space-y-2">
                    <a [routerLink]="service.path"
                       class="block font-semibold text-gray-900 hover:text-primary-600 transition-colors pb-2 border-b border-gray-100">
                      {{ service.label }}
                    </a>
                    <div class="space-y-1">
                      @for (child of service.children; track child.path) {
                        <a [routerLink]="child.path"
                           routerLinkActive="text-primary-600"
                           class="block text-sm text-gray-600 hover:text-primary-600 hover:bg-primary-50 px-2 py-1.5 rounded transition-colors">
                          {{ child.label }}
                        </a>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <!-- Blog -->
        <a routerLink="/blog"
           routerLinkActive="text-primary-600 bg-primary-50"
           class="px-3 py-2 text-sm font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200">
          Blog
        </a>

        <!-- Contact -->
        <a routerLink="/contact"
           routerLinkActive="text-primary-600 bg-primary-50"
           class="px-3 py-2 text-sm font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200">
          Contact
        </a>
      </div>

      <!-- CTA Button (Desktop) -->
      <div class="hidden lg:block" *ngIf="!isLandingPage">
        <a routerLink="/contact" class="btn-primary text-sm">
          Get Started
        </a>
      </div>

      <!-- Mobile Menu Button -->
      <button
        (click)="toggleMenu()"
        class="lg:hidden p-2 rounded-lg text-gray-600 hover:text-primary-600 hover:bg-primary-50 transition-colors"
        [attr.aria-expanded]="isMenuOpen"
        aria-label="Toggle menu">
        @if (!isMenuOpen) {
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        }
      </button>
    </div>
  </div>

  <!-- Mobile Navigation -->
  @if (isMenuOpen) {
    <div class="lg:hidden bg-white border-t border-gray-100 max-h-[80vh] overflow-y-auto">
      <div class="px-4 py-3 space-y-1">
        <!-- Home -->
        <a routerLink="/"
           routerLinkActive="text-primary-600 bg-primary-50"
           [routerLinkActiveOptions]="{exact: true}"
           (click)="closeMenu()"
           class="block px-4 py-3 text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200">
          Home
        </a>

        <!-- About -->
        <a routerLink="/about"
           routerLinkActive="text-primary-600 bg-primary-50"
           (click)="closeMenu()"
           class="block px-4 py-3 text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200">
          About
        </a>

        <!-- Services Section -->
        <div>
          <button
            (click)="toggleMobileDropdown('services')"
            class="w-full flex items-center justify-between px-4 py-3 text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200">
            Services
            <svg class="w-5 h-5 transition-transform" [class.rotate-180]="activeMobileDropdown === 'services'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          @if (activeMobileDropdown === 'services') {
            <div class="pl-4 space-y-2 mt-2">
              @for (service of services; track service.label) {
                <div class="mb-3">
                  <a [routerLink]="service.path"
                     (click)="closeMenu()"
                     class="block px-4 py-2 text-sm font-semibold text-primary-600 hover:bg-primary-50 rounded-lg">
                    {{ service.label }}
                  </a>
                  <div class="pl-4 space-y-1 mt-1">
                    @for (child of service.children; track child.path) {
                      <a [routerLink]="child.path"
                         (click)="closeMenu()"
                         routerLinkActive="text-primary-600 bg-primary-50"
                         class="block px-4 py-2 text-sm text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors">
                        {{ child.label }}
                      </a>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <!-- Blog -->
        <a routerLink="/blog"
           routerLinkActive="text-primary-600 bg-primary-50"
           (click)="closeMenu()"
           class="block px-4 py-3 text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200">
          Blog
        </a>

        <!-- Contact -->
        <a routerLink="/contact"
           routerLinkActive="text-primary-600 bg-primary-50"
           (click)="closeMenu()"
           class="block px-4 py-3 text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-all duration-200">
          Contact
        </a>

        <div class="pt-3 pb-2" *ngIf="!isLandingPage">
          <a routerLink="/contact" (click)="closeMenu()" class="btn-primary block text-center">
            Get Started
          </a>
        </div>
      </div>
    </div>
  }
</nav>

<!-- Spacer for fixed navbar -->
<div class="h-16"></div>
